import { Lens } from "monocle-ts";

import { type InsightsMetrics } from "./InsightsMetrics";
import { type StatsItem } from "./StatsItem";

// functional lenses to get / mutate props on InnsightsMetric type

export const statsLens = Lens.fromProp<InsightsMetrics<StatsItem>>()("stats");
export const totalValueLens = Lens.fromProp<InsightsMetrics<StatsItem>>()("totalValue");
export const totalValueFormattedLens = Lens.fromProp<InsightsMetrics<StatsItem>>()("totalValueFormatted");
export const diffValueLens = Lens.fromProp<InsightsMetrics<StatsItem>>()("diffValue");
export const averageValueLens = Lens.fromProp<InsightsMetrics<StatsItem>>()("averageValue");
